import React, { FC } from 'react';
import { IconX } from '../../../icons/OurIcons';
import PropertyPhotosSection from './PropertyPhotosSection';
import AddNoteForm from './AddNoteForm';
import NoteHistoryList from './NoteHistoryList';

type PropertyCommentsViewProps = {
  propertyId: string;
  commentData: any;
  refetchCommentData: () => void;
  setIsPropertyCommentsModalOpen: (open: boolean) => void;
}

const PropertyCommentsView: FC<PropertyCommentsViewProps> = ({
  propertyId,
  commentData,
  refetchCommentData,
  setIsPropertyCommentsModalOpen
}) => {
  return (
    <div className='w-full pb-8'>
      <div className='flex items-start justify-between mb-1'>
        <div>
          <h2 className='text-2xl font-bold text-gray-900'>Property Photos &amp; Notes</h2>
          <p className='text-gray-500 mt-1'>Upload photos &amp; manage note history</p>
        </div>
        <button onClick={() => setIsPropertyCommentsModalOpen(false)} className='cursor-pointer mt-1'>
          <IconX />
        </button>
      </div>
      <hr className='my-5' />

      <div className='overflow-y-auto max-h-[70vh] pr-1'>
        <PropertyPhotosSection
          propertyId={propertyId}
          commentData={commentData}
          refetchCommentData={refetchCommentData}
        />
        <AddNoteForm
          propertyId={propertyId}
          commentData={commentData}
          refetchCommentData={refetchCommentData}
        />
        <NoteHistoryList
          propertyId={propertyId}
          commentData={commentData}
          refetchCommentData={refetchCommentData}
        />
      </div>
    </div>
  );
};

export default PropertyCommentsView;
